export default __webpack_public_path__ + "static/media/internet.dab33b8c.svg";